<template>
    <!-- Dashboard Sidebar
    ================================================== -->
    <div class="dashboard-sidebar hidden-xs hidden-md">
        <div class="dashboard-sidebar-inner">
            <div class="dashboard-nav-container ">


                <div class="dashboard-nav ">
                    <div class="dashboard-nav-inner">

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'contratante'">       
                            <center>
                                <img src="/static/images/logo4.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="/static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="/static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="/static/images/icones/calendar.png"> Meus agendamentos
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Profissionais'}">
                                <router-link :to="{'name': 'Profissionais'}">
                                    <img src="/static/images/icones/stethoscope.png"> Agendar consulta
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="/static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Arquivos'}">
                                <router-link :to="{'name': 'Arquivos'}">
                                    <img src="/static/images/icones/archives.png"> Meus exames
                                </router-link>
                            </li>                            
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="/static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="/static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a href="https://neoplasiaslitoral.com.br/" target="_blank">
                                    <img src="/static/images/icones/smartphone.png"> Acessar site
                                </a>
                            </li>  
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <img src="/static/images/icones/log-out.png"> Sair
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                        
                            <li class="hidden-md hidden-lg hidden-xl hidden-sm">
                                <center style="opacity: 0.8;">                   
                                    <p style="font-size: 6px; margin-bottom: -5px; margin-top: 10vh; text-transform: uppercase; letter-spacing: 1px;">Desenvolvido por</p> <table style="width: 90px; border-spacing: 0px; border: none; margin-bottom: 0px;"><tbody><tr><td style="width: 100%; text-align: center;"><a target="_blank" class="external" href="https://negociar.org?utm_source=neoplasiaslitoral.negociar.tech&amp;utm_medium=referral&amp;utm_campaign=Sidebar&amp;utm_content=Logo"><img src="static/images/logo-negociar.png" alt="Desenvolvido por Negociar Marketing" style="width: 100%;"></a></td></tr></tbody></table>
                                </center>   
                            </li>                           
                        </ul>

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'profissional'">       
                            <center>
                                <img src="/static/images/logo4.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="/static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="/static/images/icones/calendar.png"> Agendamentos
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="/static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="/static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>             
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="/static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="/static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a href="https://neoplasiaslitoral.com.br/" target="_blank">
                                    <img src="/static/images/icones/smartphone.png"> Acessar site
                                </a>
                            </li>  
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <img src="/static/images/icones/log-out.png"> Sair
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                        
                            <li class="hidden-md hidden-lg hidden-xl hidden-sm">
                                <center style="opacity: 0.8;">                   
                                    <p style="font-size: 6px; margin-bottom: -5px; margin-top: 10vh; text-transform: uppercase; letter-spacing: 1px;">Desenvolvido por</p> <table style="width: 90px; border-spacing: 0px; border: none; margin-bottom: 0px;"><tbody><tr><td style="width: 100%; text-align: center;"><a target="_blank" class="external" href="https://negociar.org?utm_source=neoplasiaslitoral.negociar.tech&amp;utm_medium=referral&amp;utm_campaign=Sidebar&amp;utm_content=Logo"><img src="static/images/logo-negociar.png" alt="Desenvolvido por Negociar Marketing" style="width: 100%;"></a></td></tr></tbody></table>
                                </center>   
                            </li>                           
                        </ul>
                       
                        <ul data-submenu-title="" v-if="$root.user.tipo == 'admin'">       
                            <center>
                                <img src="/static/images/logo4.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="/static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="/static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>                            
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="/static/images/icones/calendar.png"> Agendamentos
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="/static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Campanhas'}">
                                <router-link :to="{'name': 'Campanhas'}">
                                    <img src="/static/images/icones/tick.png"> Campanhas
                                </router-link>
                            </li> 
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Mural'}">
                                <router-link :to="{'name': 'Mural'}">
                                    <img src="/static/images/icones/document.png"> Mural de recados
                                </router-link>
                            </li>   
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Relatorios'}">
                                <router-link :to="{'name': 'Relatorios'}">
                                    <img src="/static/images/icones/page.png"> Relatórios
                                </router-link>
                            </li>                           
                            <li v-bind:class="{'active': $router.currentRoute.name == 'UsuariosGeral'}">
                                <router-link :to="{'name': 'UsuariosGeral'}">
                                    <img src="/static/images/icones/user.png"> Usuários
                                </router-link>
                            </li>    
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Configuracoes'}">
                                <router-link :to="{'name': 'Configuracoes'}">
                                    <img src="/static/images/icones/gear.png"> Configurações
                                </router-link>
                            </li>                                                                           
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="/static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="/static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a href="https://neoplasiaslitoral.com.br/" target="_blank">
                                    <img src="/static/images/icones/smartphone.png"> Acessar site
                                </a>
                            </li>  
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <img src="/static/images/icones/log-out.png"> Sair
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                        
                            <li class="hidden-md hidden-lg hidden-xl hidden-sm">
                                <center style="opacity: 0.8;">                   
                                    <p style="font-size: 6px; margin-bottom: -5px; margin-top: 10vh; text-transform: uppercase; letter-spacing: 1px;">Desenvolvido por</p> <table style="width: 90px; border-spacing: 0px; border: none; margin-bottom: 0px;"><tbody><tr><td style="width: 100%; text-align: center;"><a target="_blank" class="external" href="https://negociar.org?utm_source=neoplasiaslitoral.negociar.tech&amp;utm_medium=referral&amp;utm_campaign=Sidebar&amp;utm_content=Logo"><img src="static/images/logo-negociar.png" alt="Desenvolvido por Negociar Marketing" style="width: 100%;"></a></td></tr></tbody></table>
                                </center>   
                            </li>                           
                        </ul>

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'marketing'">       
                            <center>
                                <img src="/static/images/logo4.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="/static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="/static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>                            
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Campanhas'}">
                                <router-link :to="{'name': 'Campanhas'}">
                                    <img src="/static/images/icones/tick.png"> Campanhas
                                </router-link>
                            </li> 
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Mural'}">
                                <router-link :to="{'name': 'Mural'}">
                                    <img src="/static/images/icones/document.png"> Mural de recados
                                </router-link>
                            </li>                                                
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="/static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="/static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a href="https://neoplasiaslitoral.com.br/" target="_blank">
                                    <img src="/static/images/icones/smartphone.png"> Acessar site
                                </a>
                            </li>  
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <img src="/static/images/icones/log-out.png"> Sair
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px; padding-top: 5px; padding-bottom: 5px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                      
                            <li class="hidden-md hidden-lg hidden-xl hidden-sm">
                                <center style="opacity: 0.8;">                   
                                    <p style="font-size: 6px; margin-bottom: -5px; margin-top: 10vh; text-transform: uppercase; letter-spacing: 1px;">Desenvolvido por</p> <table style="width: 90px; border-spacing: 0px; border: none; margin-bottom: 0px;"><tbody><tr><td style="width: 100%; text-align: center;"><a target="_blank" class="external" href="https://negociar.org?utm_source=neoplasiaslitoral.negociar.tech&amp;utm_medium=referral&amp;utm_campaign=Sidebar&amp;utm_content=Logo"><img src="static/images/logo-negociar.png" alt="Desenvolvido por Negociar Marketing" style="width: 100%;"></a></td></tr></tbody></table>
                                </center>   
                            </li>                           
                        </ul>

                    </div>
                </div>
                

            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    name: 'Sidebar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue